import React, { ReactHTMLElement, SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import {
  faTrashAlt,
  faPencilAlt,
  faPlus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import style from './DateRangeCard.scss'
import DateRange from '../DateRange/DateRange'
import IProps, { IAction } from './IProps'

const DateRangeCard = (props: IProps) => {
  const { t } = useTranslation()
  const actions: IAction[] = props.actions ? props.actions : []

  const iconMap = {
    update: faPencilAlt,
    delete: faTrashAlt,
    add: faPlus,
  }

  let overlay: ReactHTMLElement<HTMLDivElement>
  if (props.overlay) {
    overlay = React.cloneElement(props.overlay, {
      className: `${props.overlay.props.className} ${style.overlay}`,
    })
  }

  const onActionClicked = (
    e: SyntheticEvent<HTMLButtonElement>,
    action: IAction,
  ) => {
    action.callback()
    e.currentTarget.blur()
  }

  return (
    <div className={style.dateRangeCard}>
      <div className={style.dates}>
        <DateRange start={props.startsAt} end={props.endsAt} />
      </div>
      <div className={style.content}>
        <div className={style.title}>{props.title}</div>
        <div className={style.days}>
          {t('{{count}} days', {
            count:
              Math.round(props.endsAt.diff(props.startsAt, 'days', true) * 10) /
              10,
          })}
        </div>
        {props.description && props.description.length > 0 ? (
          <div className={style.description}>{props.description}</div>
        ) : null}
      </div>
      <div
        className={style.actions}
        style={{ alignItems: 'center', paddingRight: '1rem' }}>
        {actions.map((action: IAction, index: number) => {
          return (
            <button
              className={`a-style ${action.style && style[action.style]}`}
              onClick={e => {
                onActionClicked(e, action)
              }}
              style={{ width: '50px', height: '50px', textAlign: 'center' }}
              key={`dateRangeCardAction${index}`}>
              <FontAwesomeIcon icon={iconMap[action.icon]} />
            </button>
          )
        })}
      </div>
      {overlay ? overlay : null}
    </div>
  )
}

export default DateRangeCard
